<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.SelectContainerInfo')"
    width="850px"
    :close-on-click-modal="false"
    class="app-main-inner"
  >
    <cargo-ag-grid
      config-module="130203"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="width:100%;height:300px"
      @gridReady="params=>{gridApi=params.api}"
    />
    <span slot="footer">
      <el-button type="primary" no="1" @click="confirm">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
      <el-button no="2" @click="innerVisible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { getEdiContainerList } from '@/api/seaExport/seaCargoDoc'

export default {
  name: 'CargoDocUsageSelectedDialog',
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: true },
    docType: { type: String, required: true },
    uuidNotEmpty: { type: Boolean, default: false }
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          headerCheckboxSelection: true,
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('CargoMsg.Cargo_ContainerSize'),
          field: 'eqSize',
          width: 100,
          cellRenderer: (params) => {
            const data = this.isOriginalValue ? params.data : params.data.container
            return data.eqSize + "'"
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ContainerType'),
          field: 'eqType',
          width: 100,
          cellRenderer: (params) => {
            const data = this.isOriginalValue ? params.data : params.data.container
            return data.eqType
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ContainerNo'),
          field: 'containerNo',
          width: 100,
          cellRenderer: (params) => {
            const data = this.isOriginalValue ? params.data : params.data.container
            return data.containerNo
          }
        }, {
          headerName: this.$t('SeaExport.SealNo'),
          field: 'sealNo',
          width: 100,
          cellRenderer: (params) => {
            const data = this.isOriginalValue ? params.data : params.data.container
            return data.sealNo
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ItemsNBR'),
          field: 'quantity',
          width: 100
        }, {
          headerName: this.$t('SeaExport.Weight'),
          field: 'weight',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Cubage'),
          field: 'cubage',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        }
      ],
      rowData: [],
      gridApi: null
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.rowData = []
      }
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
  },
  methods: {
    async toQuery() {
      if (!this.job.uuid) {
        this.rowData = []
        return
      }
      const job = new SeaExportJob(this.job)
      let jointSlaves = null
      // 如果是新版的ams 或者 afr 则需要先判断是否是hbl并单 如果是则取hbl并单的装箱信息，否则取job装箱信息
      if (this.docType === CargoDocConsts.AMS_NEW || this.docType === CargoDocConsts.AFR_NEW) {
        if (job.typeHBL === BillType.MERGE_BILL_TYPE.code) {
          for (const doc of job.cargoDoc) {
            if (doc.docType === CargoDocConsts.HBL2) {
              this.rowData = await getEdiContainerList({ cargoDocUuid: doc.uuid }).then(res => res.data) || []
              console.log('this.rowData', this.rowData)
              return
            }
          }
        }
      }
      if (this.docType === CargoDocConsts.MBL2) {
        jointSlaves = await job.getJointSlavesMBL()
      } else {
        jointSlaves = await job.getJointSlavesHBL()
      }
      let rowData = []
      if (job.masterFlag && this.docType === CargoDocConsts.AFR) {
        await job.loadJobRelated({ containers: true })
        let containers = []
        if (job.containers && job.containers.length > 0) {
          for (const container of job.containers) {
            if (container.containerUsage && container.containerUsage.length > 0) {
              containers = containers.concat(container.containerUsage)
            }
          }
        }
        rowData = containers
      } else {
        await job.loadJobRelated({ containerUsages: true })
        rowData = job.containerUsages
      }
      if ((this.docType === CargoDocConsts.MBL2 && job.typeMBL === BillType.MERGE_BILL_TYPE.code ||
        this.docType === CargoDocConsts.HBL2 && job.typeHBL === BillType.MERGE_BILL_TYPE.code) &&
        jointSlaves && jointSlaves.length > 0) {
        let uuids = ''
        if (jointSlaves.length > 1) {
          for (const job of jointSlaves) {
            if (uuids) {
              uuids = uuids + ',' + job.uuid
            } else {
              uuids = job.uuid
            }
          }
        } else if (jointSlaves.length === 1) {
          uuids = jointSlaves[0].uuid
        }
        rowData = rowData.concat(await SeaExportJob.getListJobContainerUsages(uuids))
      }
      if (this.uuidNotEmpty) {
        this.rowData = rowData.filter(p => p.uuid)
      } else {
        this.rowData = rowData
      }
    },
    confirm() {
      const rows = this.gridApi.getSelectedRows()
      this.$emit('callback', rows)
      this.innerVisible = false
    },
    isOriginalValue() {
      if ((this.job.masterFlag && this.docType === CargoDocConsts.AFR) ||
        this.docType === CargoDocConsts.AMS_NEW ||
        this.docType === CargoDocConsts.AFR_NEW) {
        return true
      }
      return false
    }
  }
}
</script>

<style>
</style>
